import { useState } from 'react';
import { ChevronRight } from 'lucide-react';
import { orDash } from '../../../../utils/schema-parse';
import formatDecimal from '../../../../utils/format-decimal';
import { formatPeriodo } from '../../../../utils/format-date';
import type { RelatorioVisita } from '../../schemas/payload.schema';
import RecomendacoesDetalhesModal from './recomendacoes-detalhes-modal';
import formatArea from '../../../../utils/format-medida';

interface RecomendacoesSectionProps {
  recomendacoes: RelatorioVisita['recomendacoes'];
}

const RecomendacoesSection = ({
  recomendacoes = [],
}: RecomendacoesSectionProps) => {
  const [detalhesOpen, setDetalhesOpen] = useState(false);

  if (recomendacoes.length === 0) return null;

  return (
    <section className="rv-rec">
      <div className="rv-rec-header">
        <h2 className="rv-rec-title">Recomendações Técnicas</h2>
        <button
          type="button"
          className="rv-rec-details-btn"
          onClick={() => setDetalhesOpen(true)}
        >
          Ver detalhes
          <ChevronRight size={16} />
        </button>
      </div>

      <div className="rv-rec-list">
        {recomendacoes.map((recomendacao, index) => {
          const periodo = formatPeriodo(
            recomendacao.dataInicio,
            recomendacao.dataFim,
          );
          const area = formatArea(recomendacao.gleba?.areaHa);
          const produtos = recomendacao.produtos ?? [];

          return (
            <div
              // eslint-disable-next-line react/no-array-index-key
              key={`${recomendacao.gleba?.id ?? 'gleba'}-${
                recomendacao.atividade
              }-${index}`}
              className="rv-rec-card"
            >
              <div className="rv-rec-card-head">
                <div className="rv-rec-gleba">
                  {orDash(recomendacao.gleba?.descricao)}
                  {area ? ` (${area})` : ''}
                </div>
                <div className="rv-rec-atividade">
                  {orDash(recomendacao.atividade)}
                  {periodo ? `  ·  ${periodo}` : ''}
                </div>
              </div>

              <div className="rv-rec-card-body">
                <div className="rv-rec-produtos-head">
                  <span className="rv-rec-label">Produto</span>
                  <span className="rv-rec-label">Dose</span>
                </div>
                <div className="rv-rec-produtos-list">
                  {produtos.length > 0 ? (
                    produtos.map((produto, produtoIndex) => (
                      <div
                        // eslint-disable-next-line react/no-array-index-key
                        key={`${produto.descricao}-${produtoIndex}`}
                        className="rv-rec-produto"
                      >
                        <span className="rv-rec-produto-name">
                          {orDash(produto.descricao)}
                        </span>
                        <span className="rv-rec-dose">
                          {formatDecimal(produto.dose)}{' '}
                          {orDash(produto.unidade)}
                        </span>
                      </div>
                    ))
                  ) : (
                    <span className="rv-rec-empty">-</span>
                  )}
                </div>
              </div>
            </div>
          );
        })}
      </div>

      <RecomendacoesDetalhesModal
        open={detalhesOpen}
        recomendacoes={recomendacoes}
        onClose={() => setDetalhesOpen(false)}
      />
    </section>
  );
};

export default RecomendacoesSection;
